import { render } from "./FinalizarChatModal.vue?vue&type=template&id=19ab7b2f"
import script from "./FinalizarChatModal.vue?vue&type=script&lang=js"
export * from "./FinalizarChatModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__